import { itemAddApi } from "../../api/item/itemAddApi"

type PayloadShape = Parameters<typeof itemAddApi>[0]

export async function itemAddService(payload: PayloadShape, token: string) {
	payload.rate = +payload.rate
	return await itemAddApi(payload, token)
}
